module.exports = __webpack_public_path__ + "media/img/vca/step2-0d1a42da9f9a06354dd07991f0154f47.png";